<template>
  <pt-goods-qr-code class="pt-goods-qr-code__withData" @deleteQrCode="deleteQrCode" @downloadQrCode="downloadQrCode" ref="table"></pt-goods-qr-code>
</template>

<script>
import PtGoodsQrCode from './index'
export default {
  name: 'pt-goods-qr-code__withData',
  components: {
    'pt-goods-qr-code': PtGoodsQrCode
  },
  methods: {
    deleteQrCode (id) {
      this.$store.dispatch('deleteQrCode', id).then(res => {
        this.$refs.table.getTableData()
        this.$message.success('删除二维码成功')
      }).catch(err => {
        this.$message.error(err || '删除二维码失败')
      })
    },
    downloadQrCode (id) {
      this.$store.dispatch('downloadQrCode', id).then(res => {
        this.$message.success('下载二维码成功')
      }).catch(err => {
        this.$message.error(err || '下载二维码失败')
      })
    }
  }
}
</script>
